/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createFilterTransform } from '../../factoriesAny.js';
export var filterTransformDependencies = {
  typedDependencies: typedDependencies,
  createFilterTransform: createFilterTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesFilterTransform.generated.js
// module id = 1547
// module chunks = 0